import { useEffect, useState } from "react";

import {
  getWorkspaceMembers,
  getWorkspaceItems,
} from "../../services/workspaceService";

import {
  extractArray,
} from "../../workspaces/workspaceCalculations";


const getWorkspaceUuid = (workspace) => {
  return (
    workspace?.uuid ||
    workspace?.workspace_uuid ||
    workspace?.workspaceUuid ||
    workspace?.id ||
    null
  );
};


const getCompletedCount = (items) => {
  if (!Array.isArray(items)) {
    return 0;
  }

  return items.filter((item) => {
    const status = String(
      item?.status ||
      item?.item_status ||
      ""
    )
      .trim()
      .toLowerCase();

    return (
      status === "completed" ||
      status === "complete" ||
      status === "done"
    );
  }).length;
};


export const useWorkspaceStats = (workspace) => {

  const [stats, setStats] = useState({
    members: 0,
    items: 0,
    completedItems: 0,
    progress: 0,
    loading: false,
    error: null,
  });


  useEffect(() => {

    let cancelled = false;


    const fetchStats = async () => {

      const workspaceUuid =
        getWorkspaceUuid(workspace);


      if (!workspaceUuid) {

        setStats({
          members: 0,
          items: 0,
          completedItems: 0,
          progress: 0,
          loading: false,
          error: "Workspace UUID missing",
        });

        return;
      }


      try {

        setStats((previous) => ({
          ...previous,
          loading: true,
          error: null,
        }));


        console.log(
          "========================================"
        );

        console.log(
          "FETCHING WORKSPACE STATS"
        );

        console.log(
          "WORKSPACE UUID:",
          workspaceUuid
        );

        console.log(
          "========================================"
        );


        const [
          membersResponse,
          itemsResponse,
        ] = await Promise.all([
          getWorkspaceMembers(
            workspaceUuid
          ),

          getWorkspaceItems(
            workspaceUuid
          ),
        ]);


        console.log(
          "MEMBERS API RESPONSE:",
          membersResponse
        );

        console.log(
          "ITEMS API RESPONSE:",
          itemsResponse
        );


        const members =
          extractArray(
            membersResponse
          );


        const items =
          extractArray(
            itemsResponse
          );


        const totalMembers =
          members.length;


        const totalItems =
          items.length;


        const completedItems =
          getCompletedCount(items);


        const progress =
          totalItems > 0
            ? Math.round(
                (completedItems /
                  totalItems) *
                  100
              )
            : 0;


        console.log(
          "WORKSPACE STATS:",
          {
            workspaceUuid,
            members: totalMembers,
            items: totalItems,
            completedItems,
            progress,
          }
        );


        if (cancelled) {
          return;
        }


        setStats({
          members: totalMembers,
          items: totalItems,
          completedItems,
          progress: Math.min(
            Math.max(progress, 0),
            100
          ),
          loading: false,
          error: null,
        });

      } catch (error) {

        console.error(
          "WORKSPACE STATS ERROR:",
          error
        );


        if (cancelled) {
          return;
        }


        setStats({
          members: 0,
          items: 0,
          completedItems: 0,
          progress: 0,
          loading: false,
          error:
            error.response?.data
              ?.message ||
            "Failed to load workspace statistics",
        });
      }
    };


    fetchStats();


    return () => {
      cancelled = true;
    };

  }, [workspace]);


  return stats;
};